import {
    MockupColorScheme,
    MockupDeviceType,
    MockupType,
    MockupOrientation,
    MockupSettings,
    Mockup,
    MockupSettingsGroups
} from "@/scripts/common/mockupStore/mockupStructure.js";

export const mobileMockups = {
    [MockupDeviceType.MOBILE]: {
        [MockupType.REALISTIC]: {
            'v1': new Mockup(
                'mobile-realistic-v1',
                MockupDeviceType.MOBILE,
                MockupType.REALISTIC,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v1',
                [MockupSettingsGroups.LAPTOP_NOTCH],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
            'v3': new Mockup(
                'mobile-realistic-v3',
                MockupDeviceType.MOBILE,
                MockupType.REALISTIC,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v3',
                [MockupSettingsGroups.NOTCH],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
        },
        [MockupType.SEMI_REALISTIC]: {
            'v1': new Mockup(
                'mobile-semi-realistic-v1',
                MockupDeviceType.MOBILE,
                MockupType.SEMI_REALISTIC,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v1',
                [MockupSettingsGroups.LAPTOP_NOTCH],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
            'v2': new Mockup(
                'mobile-semi-realistic-v2',
                MockupDeviceType.MOBILE,
                MockupType.SEMI_REALISTIC,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v2',
                [],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
            'v3': new Mockup(
                'mobile-semi-realistic-v3',
                MockupDeviceType.MOBILE,
                MockupType.SEMI_REALISTIC,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v3',
                [MockupSettingsGroups.NOTCH],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
        },
        [MockupType.SIMPLE]: {
            'v2': new Mockup(
                'mobile-simple-v2',
                MockupDeviceType.MOBILE,
                MockupType.SIMPLE,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v2',
                [],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
            'v3': new Mockup(
                'mobile-simple-v3',
                MockupDeviceType.MOBILE,
                MockupType.SIMPLE,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v3',
                [MockupSettingsGroups.NOTCH],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
        },
        [MockupType.OUTLINE]: {
            'v1': new Mockup(
                'mobile-outline-v1',
                MockupDeviceType.MOBILE,
                MockupType.OUTLINE,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v1',
                [],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
            'v2': new Mockup(
                'mobile-outline-v2',
                MockupDeviceType.MOBILE,
                MockupType.OUTLINE,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v2',
                [],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
        },
        [MockupType.BROWSER]: {
            'v2': new Mockup(
                'mobile-browser-v2',
                MockupDeviceType.MOBILE,
                MockupType.BROWSER,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v2',
                [MockupSettingsGroups.CORNER],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
        },
        [MockupType.TRADITIONAL]: {
            'v1': new Mockup(
                'mobile-traditional-v1',
                MockupDeviceType.MOBILE,
                MockupType.TRADITIONAL,
                [MockupColorScheme.LIGHT, MockupColorScheme.DARK],
                'v1',
                [],
                [MockupOrientation.PORTRAIT, MockupOrientation.LANDSCAPE]
            ),
        },
        [MockupType.MINIMAL]: {
            'v2': new Mockup(
                'mobile-minimal-v2',
                MockupDeviceType.MOBILE,
                MockupType.MINIMAL,
                [MockupColorScheme.LIGHT],
                'v2',
                [MockupSettingsGroups.CORNER],
                [MockupOrientation.PORTRAIT]
            ),
        }
    },
}